import axios from "axios"

export default axios.create({
  baseURL: "https://api.ydlearning.com/"
})



// WEBPACK FOOTER //
// ./src/store/api.js